var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.704 5.556c-1.896.422-3.074 1.177-4.359 4.256-1.284 3.08-1.577 6.57.184 7.396.934.437 1.63-.058 2.711-1.023 1.643-1.468 2.585-3.211 5.67-3.211 3.084 0 3.868 2.017 5.164 3.21 1.297 1.195 2.525 1.758 3.772.787 1.246-.97 1.081-4.012-.268-7.159-1.348-3.146-2.687-3.825-4.337-4.256-1.651-.431-6.64-.422-8.537 0z",
    fill: "#C9C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.588 9.59c-.648 1.284-1.358 6.767 0 7.544.887.507 1.463.182 2.544-.783 1.643-1.468 2.784-3.438 5.868-3.438 4.014 0 5.208 3.987 6.391 4.22.08.017 1.5.32 1.857.166.887-.38.998-1.838.52-1.393-.477.445-1.246.508-1.818.209-1.05-.548-1.986-1.87-2.453-2.393-.721-.81-2.279-1.749-4.497-1.749s-3.199.536-3.849.94c-1.17.726-1.281.809-2.681 1.904-.6.469-1.185-.114-1.358-1.095-.194-1.1-.081-4.523 1.19-6.173.265-.342-1.066.759-1.714 2.042z",
    fill: "#9788FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15 5.647c4.962-.31 8.147.953 9.432 4.033 1.284 3.079.085 6.998.158 6.658.12-.567.04-1.498-.158-2.413-.466-2.152-.921-4.889-3.518-6.715-.85-.598-3.498-.386-4.825-.386-1.328 0-2.752-.232-3.722-.195-1.413.054-2.674.66-3.354 1.283.322-1.009.44-1.613 2.37-1.995.785-.156 3.851-.27 3.617-.27z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.697 5.713C3.767 6.032 2.61 7.08 1.452 9.83c-1.278 3.032-1.256 6.368-.017 7.123.824.503 1.55.289 2.672-.704.236-.209.463-.432.748-.732l.452-.481c1.505-1.599 2.602-2.22 4.685-2.22 2.154 0 3.154.651 4.483 2.38l.234.303c.26.336.45.564.655.78.97 1.017 2.359 1.274 3.338.675 1.094-.67 1.086-4.155-.197-7.118-1.172-2.707-2.447-3.82-4.269-4.123-.455-.076-1.013-.103-1.7-.093-.365.006-.715.02-1.267.048-.852.044-.982.05-1.274.052-.313.002-.494-.006-1.378-.05-.526-.026-.854-.04-1.199-.046-.7-.012-1.263.014-1.72.09z",
    stroke: "#2D2734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 2c1.323.202 1.184 1.361.517 1.66-.668.3-.641 1.552.164 1.711",
    stroke: "#2D2734",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.096 5.763c-.007-.4-.118-.608.416-.728.535-.12 1.672-.302 2.148-.353.475-.05.624.033.685.516.061.484-3.242.965-3.249.565zm11.234 0c.007-.4.119-.608-.416-.728a27.094 27.094 0 0 0-2.147-.353c-.476-.05-.624.033-.685.516-.061.484 3.241.965 3.248.565z",
    fill: "#2D2734"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F87C2F",
    transform: "rotate(2 4.738 3.028)",
    cx: 4.738,
    cy: 3.028,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1BE09",
    transform: "rotate(2 1.285 1.404)",
    cx: 1.285,
    cy: 1.404,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB462",
    transform: "rotate(2 4.675 2.476)",
    cx: 4.675,
    cy: 2.476,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEB79",
    transform: "rotate(2 1.703 .81)",
    cx: 1.703,
    cy: 0.81,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2D2734"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.465 11.602a.665.665 0 1 0 .046-1.329.665.665 0 0 0-.046 1.33zm-.035 1a1.665 1.665 0 1 1 .116-3.328 1.665 1.665 0 0 1-.116 3.328zm-2.97-2.627a.665.665 0 1 0 .047-1.329.665.665 0 0 0-.046 1.33zm-.034 1a1.665 1.665 0 1 1 .116-3.328 1.665 1.665 0 0 1-.116 3.328z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.625 9.125H7.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.875v.875a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-.875H4.25a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h.875V8.25a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.875z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.dc5ab7220cde4a8a893f138ea3dc2eae.svg";
export { ForwardRef as ReactComponent };